import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/gmain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/gmain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/gmain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/gmain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/gmain/${Id}`);
  },
};
